import { reactive, computed } from 'vue';

// Маленький роутер на History API. vue-router сюда не тянем: у нас пять
// маршрутов и ни одного вложенного — зависимость не окупается.

const routes = [];

// Реактивен только путь. Параметры и имя маршрута ВЫЧИСЛЯЮТСЯ из него, а не
// хранятся: раньше они снимались один раз при загрузке этого модуля — то есть
// ДО того, как main.js успевал вызвать addRoute. Список маршрутов в тот момент
// пуст, поэтому при прямом заходе и после F5 параметры оставались пустыми, и
// страница собеса запрашивала /api/interview/NaN/report. При переходах внутри
// приложения navigate() пересчитывал их заново, и потому баг не был виден.
const current = reactive({ path: location.pathname });

/**
 * @param {string} pattern  '/project/:id'
 * @param {string} name
 * @param {object} component
 */
export function addRoute(pattern, name, component) {
  const keys = [];
  const regex = new RegExp('^' + pattern.replace(/:([^/]+)/g, (_, k) => {
    keys.push(k);
    return '([^/]+)';
  }) + '/?$');
  routes.push({ regex, keys, name, component });
}

function resolve(path) {
  for (const r of routes) {
    const m = r.regex.exec(path);
    if (!m) continue;
    const params = {};
    r.keys.forEach((k, i) => { params[k] = m[i + 1]; });
    return { ...r, params };
  }
  return null;
}

export const matched = computed(() => resolve(current.path));

export const route = {
  get path() { return current.path; },
  set path(value) { current.path = value; },
  get params() { return matched.value?.params || {}; },
  get name() { return matched.value?.name || ''; },
};

export function navigate(path, replace = false) {
  if (path === current.path) return;
  history[replace ? 'replaceState' : 'pushState']({}, '', path);
  current.path = path;
  window.scrollTo(0, 0);
}

window.addEventListener('popstate', () => { current.path = location.pathname; });

/** <router-link to="/projects">Проекты</router-link> */
export const RouterLink = {
  props: { to: { type: String, required: true }, exact: Boolean },
  computed: {
    active() {
      return this.exact ? route.path === this.to : route.path.startsWith(this.to);
    },
  },
  methods: {
    go(e) {
      // Средняя кнопка и Ctrl+клик должны открывать вкладку как обычно.
      if (e.metaKey || e.ctrlKey || e.button !== 0) return;
      e.preventDefault();
      navigate(this.to);
    },
  },
  template: `<a :href="to" :class="{ active }" @click="go"><slot/></a>`,
};
